import GenericCard from '../../../../components/GenericCards';
import { Col, Row } from 'react-bootstrap';
import Label from '../../../../components/Label';
import Button from '../../../../components/Button';
import Link from '../../../../components/Link';
import React, { useState } from 'react';

export const CurrentLoans = () => {
  const [showMoreDetails, setShowMoreDetails] = useState<boolean>(false);

  const handleShowMoreDetails = () => {
    setShowMoreDetails((prevState) => !prevState);
  };

  return (
    <GenericCard variant={'white'}>
      <Row className="align-items-center">
        <Col className={'col-10'}>
          <h5>Current Loans</h5>
        </Col>
      </Row>
      <Row className="justify-content-between align-content-center align-items-center">
        <Col className={'col-lg-4 col-12'}>
          <Label className={'lh-xs'}>Payment</Label>
          <h4>$197.77</h4>
        </Col>
        <Col className={'col-lg-4 col-12'}>
          <Button color={'blue'} className={'w-100'}>
            Make Payment
          </Button>
        </Col>
      </Row>
      <Row className="">
        <Col className={'col-lg-4 col-6'}>
          <Label className={'lh-xs'}>
            <span className="text-dark-gray-50">Balance</span>
          </Label>
          <h6 className={'lh-xxs'}>$18,155.24</h6>
        </Col>
        <Col className={'col-lg-4 col-6'}>
          <Label className={'lh-xs'}>
            <span className="text-dark-gray-50">Remaining Payments</span>
          </Label>
          <h5>107</h5>
        </Col>
      </Row>

      <Row className={`${!showMoreDetails ? 'd-none' : 'd-block'} mt-5`}>
        <Col className={'col-12'}>
          <Row className="text-fs-6 fw-light lh-xs pt-3 pb-3 px-3 border-bottom ">
            <Col className="col-8 ps-0 ">Origination date</Col>
            <Col className="col-4 text-end pe-0">18 Mar 2022</Col>
          </Row>
          <Row className="text-fs-6 fw-light lh-xs pt-3 pb-3 px-3 border-bottom ">
            <Col className="col-8 ps-0 ">Original amount</Col>
            <Col className="col-4 text-end pe-0">$20,000.00</Col>
          </Row>
          <Row className="text-fs-6 fw-light lh-xs pt-3 pb-3 px-3 border-bottom ">
            <Col className="col-8 ps-0 ">Interest rate</Col>
            <Col className="col-4 text-end pe-0">3.5%</Col>
          </Row>
        </Col>
      </Row>

      <Link
        className="text-blue lh-xs mt-6"
        color={'blue'}
        isBlue={true}
        onClick={() => handleShowMoreDetails()}
      >
        {!showMoreDetails ? 'More details' : 'Less Details'}
      </Link>
    </GenericCard>
  );
};
